import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ScreenService } from 'core/services';
import { LicensesPresenter } from './presenter';

export const Licenses: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{ScreenService.getDocumentTitle(t('global.license'))}</title>
      </Helmet>
      <LicensesPresenter />
    </>
  );
};
